import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class GridCurve {

  public valuesIsCheap: number[] | null = null;
  public valuesTariff: string[] | null = null;
  public valuesIsAvailable: number[] | null = null;
  public valuesPrice: number[] | null = null;

  public durationYear: number | null = null;

  public startDate: Date | null = null;

  public stepMinutes: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.startDate = this.startDate ? new Date(this.startDate) : null;
  }

}
